module.exports = __webpack_public_path__ + "img/adhka-yx1zn.010.aeedae54.png";